require("../sass/datamotive.scss");
(function ($) {
  $(document).ready(function () {
    $(".icon-megamenu-close").click(function (e) {
      e.preventDefault();
      $(".dropdown-mega-block").toggleClass("megamenu-hide");
      setTimeout(function () {
        $(".dropdown-mega-block").removeClass("megamenu-hide");
      }, 500);
    });

    $(".mobile-menu-button a.menu-open").click(function () {
      if ($("body").hasClass("mobile-menu-active")) {
        closeMobileMenu($("#mobile-menu"));
      } else {
        openMobileMenu($("#mobile-menu"), false);
      }
      return false;
    });

    //GA code for Menu and Vehicles Section
    googleAnalytics();

    $(".buyers-tools-nav").mouseover(function () {
      if ($(".buyers-tools").hasClass("mouseout")) {
        $(".buyers-tools").removeClass("mouseout").addClass("mouseover");
      }
      if ($(".buyers-tools").hasClass("inactive")) {
        $(".buyers-tools").removeClass("inactive").addClass("active");
      }
    });

    $(".buyers-tools li i").click(function () {
      if ($(".buyers-tools").hasClass("inactive")) {
        $(".buyers-tools").removeClass("inactive").addClass("active");
      }
      return false;
    });

    /* Hide Buyers-Tools bar when user scroll down.*/
    if ($(".buyers-tools").hasClass("mouseout")) {
      $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if ($(".buyers-tools").hasClass("active")) {
          $(".buyers-tools").removeClass("active").addClass("inactive");
        }
      });
    }
  });

  function openMobileMenu(menu, focus) {
    if ($('.body-wrapper').length == 0) {
        activateMobileMenu(menu);
    }

    $("body").addClass("mobile-menu-active");

    if (focus) {
      menu.find(".gsc-input input").focus();
    }
    $(".body-wrapper").on('touchmove',HandleTouchmove);
  }

  function closeMobileMenu(menu) {
    $("body").removeClass("mobile-menu-active");
    $(".body-wrapper").off('touchmove',HandleTouchmove);
  }

  function HandleTouchmove(e) {
    e.preventDefault();
  }
  
  function activateMobileMenu(menu) {
    var body = $("body");
    body.find("script").remove().end().wrapInner('<div class="body-wrapper"></div>');

    menu.prependTo("body");
    $("table.gstl_50").appendTo(menu);
    var bodyWrapper = $(".body-wrapper");
    bodyWrapper.append('<div class="mobile-menu-blockout"></div><div class="mobile-menu-close"></div>');
    $(".mobile-menu-close").click(function () {
      closeMobileMenu($("#mobile-menu"));
      return false;
    });
    bodyWrapper.click(function () {
      if (body.hasClass("mobile-menu-active")) {
        closeMobileMenu($("#mobile-menu"));
        return false;
      }
    });   

    menu.find('.dropdown-element .dropdown-arrow').click(activateMobileDropdownMenuDefault);
    menu.find('.main-menu-buyers.dropdown-element').click(activateMobileDropdownMenuBuyersTools);
  }

  function activateMobileDropdownMenuDefault(){
      mobileMenuCommon($(this).parent('.dropdown-element'));
  }

  function activateMobileDropdownMenuBuyersTools(){
      mobileMenuCommon($(this));
  }

  function mobileMenuCommon (element) {
      if (element.hasClass('dropdown-element-active')) {
          element.find('.dropdown-block').slideUp(300, function () {
              element.removeClass('dropdown-element-active');
          });
      } else {
          element.find('.dropdown-block').slideDown(300, function () {
              element.addClass('dropdown-element-active');
          });
      }
  }

  //Google Analytics (GA) function
  function googleAnalytics() {
    //Add tracking code to the Vehicles Nav
    $(".menu-item .thumbnail a, .caption a").each(function (i, obj) {
      var tmp_link = $(this).attr("href");
      var total_event = 0;
      var total_event_hoverstate = 0;
      if (tmp_link === "/impreza") {
        total_event = 9656;
        total_event_hoverstate = 199743;
      } else if (tmp_link === "/liberty-overview") {
        total_event = 6154;
        total_event_hoverstate = 227620;
      } else if (tmp_link === "/brz") {
        total_event = 5692;
        total_event_hoverstate = 229362;
      } else if (tmp_link === "/new-wrx") {
        total_event = 12734;
        total_event_hoverstate = 243630;
      } else if (tmp_link === "/xv") {
        total_event = 10368;
        total_event_hoverstate = 206380;
      } else if (tmp_link === "/forester") {
        total_event = 13964;
        total_event_hoverstate = 196626;
      } else if (tmp_link === "/outback-overview") {
        total_event = 7573;
        total_event_hoverstate = 132882;
      }

      $(this).attr(
        "onClick",
        "ga('send', 'event', 'Fly-Out Nav' ,'Fly-Out Nav Click', '" + tmp_link + "' , '" + total_event + "');"
      );
      //removing mouseover GA event
      // $(this).attr(
      //   "onMouseover",
      //   "ga('send', 'event', 'Fly-Out Nav' ,'Fly-Out Nav Hoverstate', '" +
      //     tmp_link +
      //     "' , '" +
      //     total_event_hoverstate +
      //     "');"
      // );
    });

    //GA code for FORESTER Nav only.
    $(".menu-links .menu-link").each(function (i, obj) {
      if (
        $(this).children("a").attr("href") == "/forester" ||
        $(this).children("a").attr("href") == "/build-your-own?m=83"
      ) {
        var tmp_link = $(this).children("a").html();
        $(
          $(this)
            .children("a")
            .attr(
              "onClick",
              "_gaq.push(['_trackEvent','Fly-Out Nav','Fly-Out Nav Customisation','Forester Nav " + tmp_link + "']);"
            )
        );
      }
    });
  }
})(jQuery);
